import React from "react";

const Philosophy = () => {
  const sections = [
    {
      title: "グループモットー",
      content: [
        "・生こう・活こう・さあ行こう！",
        "・求め・挑戦していこう！",
        "・みんなで取りにいこう！",
        "・レッツ ゲット トゥギャザー",
        "・面白がって創る陽転思考",
        "・面白がって生きる陽転思考",
      ],
    },
    {
      title: "経営理念",
      content: [
        "我々は、八要精神、すなわち「チームワーク、健康、勤労、誠実、忍耐、敢闘精神、明朗、教養」を旨として社会に貢献することを基本使命とする。",
        "そのために・・・・",
        "1．時代の求める商品、サービスを供給しよう。",
        "2．肯定思考により「先ず相手の役に立つ」事を基本に、真心をこめた仕事をしよう。",
        "3．仕事を通じて、己を磨き、感動ある人生を築こう。",
      ],
    },
    {
      title: "社員信条",
      content: [
        "我々は社業を通じて使命感、重要感を体得し感動ある人生を、歩みます。",
        "その為に次のテーマを日々実践し、自己の内なる無限の可能性を開発します。",
        "私達は、常に感謝の気持ちを持ち、人生を肯定し、「はい！よろこんで」の精神で行動します。",
        "私達は、前向きな言葉、明るい挨拶、聞き上手をもって、相手の言葉を心と目で積極的に受け止め行動します。",
        "私達は、肯定思考により、磁力ある目標を設定し、これを、明示して広く協力者を求め実行します。",
      ],
    },
    {
      title: "基本姿勢",
      content: [
        "1.「整理・整頓」に心がけ、仕事には「ケジメ」を付けましょう。",
        "2.「任せる」という怠慢に陥らない様気を付けよう。",
        "3.独断しないで「独裁」しよう。",
        "4.「拙速」を心がけよう。",
        "5.自分の「本業」を意識しよう。",
        "6.「環境整備」に心がけて行こう。",
      ],
    },
    {
      title: "基本行動",
      content: [
        "1.「早く、短く、ホウレンソウ」を合言葉として問題に「トドメ」を刺していきます。",
        "2.「頼まれたこと」を一番にやります。",
        "3.「約束をする」「約束を守る」「約束を守らせる」事を行動の基本とします。",
        "4.「小さな約束」を大切にします。",
        "5.「社内の約束」を大切にします。",
      ],
    },
  ];

  return (
    <div className="text-center py-16">
      {/* 当社の理念 タイトル */}
      <div className="mb-16">
        <h1 className="text-3xl font-bold text-gray-800">当社の理念</h1>
        <img src="/images/image4.png" alt="装飾ライン" className="mx-auto my-2 w-32" />
      </div>

      <div className="container mx-auto px-4 md:px-20 space-y-10">
        {sections.map((section, index) => (
          <div key={index} className="flex flex-col md:flex-row space-x-6 md:items-center">
            <h2 className="text-2xl font-bold md:w-1/4 text-left pb-3">{section.title}</h2>
            <img src="/images/image6.png" alt="装飾ライン" className="hidden md:block h-40" />
            <div className="text-left text-sm w-3/4 space-y-2">
              {section.content.map((text, i) => (
                <p key={i}>{text}</p>
              ))}
            </div>
          </div>
        ))}
      </div>
      
    </div>
  );
};

export default Philosophy;
